/**
 * @ngdoc controllers
 * @memberof mercury.modules.settings
 * @name SettingsCompanyPreferencesCtrl
 */
angular.module('mercury.modules.settings.company')
.controller('SettingsCompanyPreferencesCtrl', ["CompanyLocale", "CompanyPreferences", "SalesTax", "reporttime", "$scope", "$state", "$stateParams", "$filter", "title", "userinfo", "$q", "dialog", "PayrollPayType", "helperUtils", function(CompanyLocale, CompanyPreferences, SalesTax, reporttime,
  $scope, $state, $stateParams, $filter, title, userinfo, $q, dialog, PayrollPayType, helperUtils) {
  if (!userinfo.companyName($stateParams.id)) {
    $state.go('Settings.CompanyList');
    return;
  }

  title.set('Settings - ' + userinfo.companyName($stateParams.id));

  $scope.addingPayType = false;
  $scope.countries = CompanyLocale.countries();

  $scope.loading = PayrollPayType.getAllPayTypes($stateParams.id);
  $scope.loading.then(function(results) {
    $scope.payrollSystemPayCodeOptions = results;

    if ($scope.payrollSystem) {
      $scope.payrollSystemPayCodes = $filter('filter')($scope.payrollSystemPayCodeOptions, {payrollSystem: $scope.payrollSystem});
      $scope.payrollCustomPayTypes = $filter('filter')($scope.payrollSystemPayCodeOptions, {payrollSystem: 'Custom'});

      // Add a 'editing' attribute to each pay type object to tell when a user is wanting to edit it
      angular.forEach($scope.payrollCustomPayTypes, function(payType) {
        payType.editing = false;
        // Add an PayType 'edit' model for every custom pay type
        $scope.editPayTypeValues.push({payType: payType.payType, payCode: payType.payCode});
      });
    }
  });

  // Revenue groups functionality should only appear for Cloudpos companies,
  // and then only for ones that are above 'Tier1' - Tier1 is the Starter plan.
  //
  // Note we rely on JS string comparasions here so 'Tier'2 is greater than 'Tier1'.
  $scope.showRevenueGroups = userinfo.companyPos() === 'Cloudpos' && userinfo.companyTier() > 'Tier1';

  $scope.weekStartOptions = [
    {value: '0', label: 'Sunday'},
    {value: '1', label: 'Monday'},
    {value: '2', label: 'Tuesday'},
    {value: '3', label: 'Wednesday'},
    {value: '4', label: 'Thrusday'},
    {value: '5', label: 'Friday'},
    {value: '6', label: 'Saturday'}
  ];

  $scope.clockinRoundingOptions = [
    {value: '00:01:00', label: 'Nearest Minute'},
    {value: '00:05:00', label: 'Nearest 5 Minutes'},
    {value: '00:10:00', label: 'Nearest 10 Minutes'},
    {value: '00:15:00', label: 'Nearest 15 Minutes'}
  ];

  $scope.payrollSystemOptions = [
    {value: 'AcePayroll', label: 'Ace Payroll'},
    {value: 'AffinityPayroll', label: 'Affinity Payroll'},
    {value: 'CrystalPayroll', label: 'Crystal Payroll'},
    {value: 'DataPay', label: 'DataPay'},
    {value: 'Ezypay', label: 'Ezypay'},
    {value: 'Flexitime', label: 'Flexitime'},
    {value: 'IPayroll', label: 'IPayroll'},
    {value: 'MyobExo', label: 'MYOB EXO'},
    {value: 'MyobPayroll', label: 'MYOB Payroll'},
    {value: 'PayHero', label: 'PayHero'},
    {value: 'Paysauce', label: 'Paysauce'},
    {value: 'Smartly', label: 'Smartly'}
  ];

  $scope.payrollSystemPayCodes = [];
  $scope.payrollCustomPayTypes = [];

  $scope.addPayTypeValues = {
    payType: '',
    payCode: ''
  };
  $scope.editPayTypeValues = [];

  /**
   * Sets all $scope variables with current active company's settigs/prefernce values on load of the page
   */
  var initPreferences = function() {
    $scope.companyId = $stateParams.id;
    $scope.companyProvince = userinfo.companyPreferenceGet('locale.province', $stateParams.id);
    $scope.companyTimezone = userinfo.companyPreferenceGet('locale.timeZone', $stateParams.id);
    $scope.overrideSalesTax = userinfo.companyPreferenceGet('tax.overrideSalesTax', $scope.companyId) === '1';
    $scope.dayStart = helperUtils.setTimeToLocalTZ(userinfo.companyPreferenceGet('date.daycutoff.daystart', $stateParams.id), 'HH:mm:ss');
    $scope.weekStart = userinfo.companyPreferenceGet('date.daycutoff.weekstart', $stateParams.id);
    $scope.includePosClocks = userinfo.companyPreferenceGet('time.includePosClockins', $stateParams.id);
    $scope.permissionsTimeAllowsSummary = userinfo.companyPreferenceGet('permissions.timeAllowsSummary', $stateParams.id);
    $scope.clockinRounding = userinfo.companyPreferenceGet('time.clockinRounding', $stateParams.id);
    $scope.defaultFreightRate = parseInt(userinfo.companyPreferenceGet('tax.defaultFreightRate', $stateParams.id));
    $scope.payrollSystem = userinfo.companyPreferenceGet('time.payrollSystem', $stateParams.id);
  };

  // The above statments in a method to get around the oppresive regime of a linter.
  // Specifically this controller function has more than 50 statements but putting these in a method gets around it
  initPreferences();

  // since the stored Locale string is a combination of language and country, set up watches to update these
  // when one changes
  $scope.companyLanguage = CompanyLocale.getLanguageCode($scope.companyId);
  $scope.companyCountry = CompanyLocale.getCountryCode($scope.companyId);
  $scope.companyProvinces = CompanyLocale.provinces($scope.companyCountry);
  $scope.companyTimezones = CompanyLocale.timezones($scope.companyCountry);

  if ($scope.companyProvinces !== null && $scope.companyProvinces.length > 0 && $scope.companyProvince === null) {
    $scope.companyProvince = $scope.companyProvinces[0].code;
  }
  $scope.localeSalesTaxes = [];
  $scope.companySalesTaxes = {data: []};
  SalesTax.getLocaleSalesTaxAmounts($scope.companyCountry, $scope.companyProvince).then(function(result) {
    $scope.localeSalesTaxes = result;

    // Also default the company sales taxes to locale sales taxes
    if (!$scope.overrideSalesTax) {
      $scope.companySalesTaxes = {
        data: result
      };
    }
  });

  if ($scope.overrideSalesTax) {
    SalesTax.getCompanySalesTaxAmounts($scope.companyId).then(function(result) {
      $scope.companySalesTaxes = result;
    });
  }

  $scope.$watch('companyLanguage', function(newVal) { CompanyLocale.setLanguageCode($scope.companyId, newVal); });
  $scope.$watch('companyCountry', function(newCountry, oldCountry) {
    CompanyLocale.setCountryCode($scope.companyId, newCountry);
    $scope.companyProvinces = CompanyLocale.provinces($scope.companyCountry);

    if (newCountry !== oldCountry) {
      // reset the company province when we change country to avoid unexpected behaviour
      if ($scope.companyProvinces !== null && $scope.companyProvinces.length > 0) {
        $scope.companyProvince = $scope.companyProvinces[0].code;
      } else {
        $scope.companyProvince = null;
      }
    }

    $scope.salesTaxRateRefreshing = SalesTax.getLocaleSalesTaxAmounts($scope.companyCountry, $scope.companyProvince);
    $scope.salesTaxRateRefreshing.then($scope.updateTaxRates);
  });

  $scope.$watch('companyProvince', function(newProvince, oldProvince) {
    $scope.salesTaxRateRefreshing = SalesTax.getLocaleSalesTaxAmounts($scope.companyCountry, newProvince);
    $scope.salesTaxRateRefreshing
      .then($scope.updateTaxRates)
      .then(function() {
        var taxRates = $scope.companySalesTaxes.data;
        if ((newProvince !== oldProvince) && Array.isArray(taxRates) && (taxRates.length > 0)) {
          $scope.defaultSalesTax = $filter('filter')(taxRates, {rate: 1})[0].amount;
          $scope.defaultFreightRate = $scope.companySalesTaxes.data.findIndex(function(x) {
            return x.rate === 1;
          });
        }
      });
  });

  // Watch the override flag, and add a new blank set of rates if needed
  $scope.$watch('overrideSalesTax', function(newVal) {
    if (newVal && ($scope.companySalesTaxes === null || $scope.companySalesTaxes.data.length === 0)) {
      $scope.companySalesTaxes = {
        data: [
          {rate: 0, label: 'Exempt', amount: 0},
          {rate: 1, label: 'Default', amount: 0}
      ]};
    }
  });

  $scope.showPosClockMessage = $scope.includePosClocks == '0';

  $scope.$watch('payrollSystem', function() {
    $scope.payrollSystemPayCodes = $filter('filter')($scope.payrollSystemPayCodeOptions, {payrollSystem: $scope.payrollSystem});
  });

  $scope.save = function() {
    var prefSaving = CompanyPreferences.updateMany([
      {key: 'date.daycutoff.daystart', value: helperUtils.getTimeFromLocalTZ($scope.dayStart)},
      {key: 'date.daycutoff.weekstart', value: $scope.weekStart},
      {key: 'time.includePosClockins', value: $scope.includePosClocks},
      {key: 'permissions.timeAllowsSummary', value: $scope.permissionsTimeAllowsSummary},
      {key: 'time.clockinRounding', value: $scope.clockinRounding},
      {key: 'locale.locale', value: CompanyLocale.getLocaleCode($scope.companyId)},
      {key: 'locale.province', value: $scope.companyProvince},
      {key: 'locale.timeZone', value: $scope.companyTimezone},
      {key: 'tax.overrideSalesTax', value: $scope.overrideSalesTax ? '1' : '0'},
      {key: 'tax.defaultFreightRate', value: $scope.defaultFreightRate.toString()},
      {key: 'time.payrollSystem', value: $scope.payrollSystem}
    ], $stateParams.id);

    if ($scope.overrideSalesTax) {
      var taxSaving = SalesTax.setCompanySalesTaxAmounts($scope.companyId, $scope.companySalesTaxes.data);
      $scope.saving = $q.all([prefSaving, taxSaving]);
    } else {
      $scope.saving = prefSaving;
    }

    $scope.saving.then(function() {
      if ($stateParams.id == userinfo.activeCompany()) {
        reporttime.dayStart = moment($scope.dayStart).format('HH:mm:ss');
        reporttime.weekStart = $scope.weekStart;
      }

      $state.go('Settings.CompanyList');
    }, function(response) {
      if ((response.status === 400) && (response.data.modelState)) {
        var messages = [];
        for (var key in response.data.modelState) {
          if (response.data.modelState.hasOwnProperty(key)) {
            for (var i = 0; i < response.data.modelState[key].length; i++) {
              messages.push(response.data.modelState[key][i]);
            }
          }
        }
        dialog.alert(messages.join('<br/>'));
      }
    });
  };

  $scope.addCustomTaxRate = function() {
    // get the maximum used rate id
    var maxRate = 1;
    angular.forEach($scope.companySalesTaxes, function(value) {
      if (value.rate > maxRate) {
        maxRate = value.rate;
      }
    });
    $scope.companySalesTaxes.data.push({
      rate: maxRate + 1,
      label: 'New Tax Rate',
      amount: 0
    });
  };

  $scope.formatTaxSelect = function(tax) {
    return tax.rate + ': ' + tax.label + ' (' + tax.amount * 100 + '%)';
  };

  $scope.updateTaxRates = function(taxRates) {
    $scope.localeSalesTaxes = taxRates;
    $scope.companySalesTaxes = {
      data: taxRates
    };
  };

  /**
   * Runs when a user clicks the 'Create Custom Pay Type' button.
   * Shows the input boxes for the user to enter the custom pay type
   */
  $scope.addCustomPayType = function() {
    $scope.addingPayType = true;
  };

  /**
   * Runs when a user submits their new custom pay type.
   * Prepares and send the POST request, then adds the newly created custom pay type to be displayed
   */
  $scope.postCustomPayType = function() {
    var payType = $scope.addPayTypeValues.payType;
    var payCode = $scope.addPayTypeValues.payCode;
    PayrollPayType.addPayType(payType, payCode, $stateParams.id).then(function(response) {
      var newPayTypeRef = response.data;

      // Add new PayType to array that is displaying the custom pay types
      $scope.payrollCustomPayTypes.push({
        payTypeRef: newPayTypeRef,
        payrollSystem: 'Custom',
        payType: payType,
        payCode: payCode,
        deletedAt: null,
        editing: false
      });

      // Add new dedit pay type model to edit PayTypes array
      $scope.editPayTypeValues.push({payType: payType, payCode: payCode});

      $scope.addPayTypeValues.payType = '';
      $scope.addPayTypeValues.payCode = '';
    }
    );
    $scope.addingPayType = false;
  };

  /**
  * Runs when a user is creating a new custom pay type and clicks cancel.
  * Hides the input boxes and shows the 'Create Custom Pay Type' button again
  */
  $scope.cancelCustomPayType = function() {
    $scope.addingPayType = false;
    $scope.addPayTypeValues = {
      payType: '',
      payCode: ''
    };
  };

  /**
   * Runs when a user clicks the 'Edit' button on a existing custom pay type.
   * Changes the text in the table to be inputs with values of pay type/pay code allowing the user to edit them
   */
  $scope.editCustomPayType = function($index) {
    $scope.editPayTypeValues[$index].payType = $scope.payrollCustomPayTypes[$index].payType;
    $scope.editPayTypeValues[$index].payCode = $scope.payrollCustomPayTypes[$index].payCode;

    $scope.payrollCustomPayTypes[$index].editing = true;
  };

  /**
   * Run when a user is editing a pay type and cancels it.
   * Changes the inputs back to text
   */
  $scope.cancelEditCustomPayType = function($index) {
    $scope.payrollCustomPayTypes[$index].editing = false;
  };

  /**
   * Runs when a user submits their edited pay type.
   * Prepares and send the PUT request to the backend and changes the front end value to match
   */
  $scope.confirmEditCustomPayType = function($index) {
    var currentPayType = $scope.payrollCustomPayTypes[$index];

    currentPayType.payType = $scope.editPayTypeValues[$index].payType;
    currentPayType.payCode = $scope.editPayTypeValues[$index].payCode;

    PayrollPayType.editPayType(currentPayType, $stateParams.id).then(function() {
      $scope.payrollCustomPayTypes[$index] = currentPayType;
      $scope.payrollCustomPayTypes[$index].editing = false;
    });
  };

  /**
   * Runs when a user clicks the delete button.
   * Prepares the send the DELETE request to the backend then removes the pay type from the front end
   */
  $scope.deleteCustomPayType = function($index) {
    var payTypeToDelete = $scope.payrollCustomPayTypes[$index];

    PayrollPayType.removePayType(payTypeToDelete.payTypeRef, $stateParams.id)
    .then(function() {
      // remove custom pay type from front end
      $scope.payrollCustomPayTypes.splice($index, 1);
      // remove edit model from array
      $scope.editPayTypeValues.splice($index, 1);
    });
  };
}]);
